var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z",
    fill: "#A4344E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0186 3.48004C17.0786 1.54004 15.1786 1.49004 13.1886 3.48004L11.9786 4.69004C11.8786 4.79004 11.8386 4.95004 11.8786 5.09004C12.6386 7.74004 14.7586 9.86003 17.4086 10.62C17.4486 10.63 17.4886 10.64 17.5286 10.64C17.6386 10.64 17.7386 10.6 17.8186 10.52L19.0186 9.31004C20.0086 8.33004 20.4886 7.38004 20.4886 6.42004C20.4986 5.43004 20.0186 4.47004 19.0186 3.48004Z",
    fill: "#A4344E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6084 11.53C15.3184 11.39 15.0384 11.25 14.7684 11.09C14.5484 10.96 14.3384 10.82 14.1284 10.67C13.9584 10.56 13.7584 10.4 13.5684 10.24C13.5484 10.23 13.4784 10.17 13.3984 10.09C13.0684 9.81005 12.6984 9.45005 12.3684 9.05005C12.3384 9.03005 12.2884 8.96005 12.2184 8.87005C12.1184 8.75005 11.9484 8.55005 11.7984 8.32005C11.6784 8.17005 11.5384 7.95005 11.4084 7.73005C11.2484 7.46005 11.1084 7.19005 10.9684 6.91005C10.9472 6.86465 10.9267 6.81949 10.9068 6.77458C10.7592 6.44127 10.3246 6.34382 10.0668 6.60158L4.33837 12.33C4.20837 12.46 4.08837 12.71 4.05837 12.88L3.51837 16.71C3.41837 17.39 3.60837 18.03 4.02837 18.46C4.38837 18.81 4.88837 19 5.42837 19C5.54837 19 5.66837 18.99 5.78837 18.97L9.62837 18.43C9.80837 18.4 10.0584 18.28 10.1784 18.15L15.8997 12.4287C16.1592 12.1692 16.0613 11.7237 15.7237 11.5797C15.6857 11.5634 15.6473 11.5469 15.6084 11.53Z",
    fill: "#A4344E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f6eb28eb4007a76c53289ff1436b2ed1.svg";
export { ForwardRef as ReactComponent };